import { useNavigate } from '@tanstack/react-router';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { usePatentEdit } from '@/module/Author/Patent/model/PatentQuery';
import { PatentSchema, defaultPatentValues, patentSchema } from '@/module/Author/Patent/model/PatentSchema';

import { useAppNotification } from '@feature/utils';

import { PatentForm } from './PatentForm';
import { Patent } from './model/PatentTypes';

interface PatentEditProps {
  patent: Patent;
}

const convert = (patent: Patent): PatentSchema => ({
  ...patent,
});

export function PatentEdit(props: PatentEditProps) {
  const { patent } = props;
  const { t } = useTranslation();
  const { mutate, isPending, isError, isSuccess } = usePatentEdit(patent.id);

  const notification = useAppNotification();
  const onSubmit = (values: PatentSchema) => {
    mutate(values, {
      onError: notification.error,
      onSuccess: notification.success,
    });
  };

  const values = useMemo(() => convert(patent), [patent]);
  const navigate = useNavigate();

  return (
    <PatentForm
      title={t('patents.form.title.edit')}
      schema={patentSchema}
      defaultValues={defaultPatentValues}
      isError={isError}
      isSuccess={isSuccess}
      values={values}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      onCancel={() => navigate({ to: '..' })}
    />
  );
}
